export default __webpack_public_path__ + "static/media/m87-logo.4d0b8526.svg";